var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestellschnittstelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "83px",
    viewBox: "0 0 75 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944625 9.5,22.361625 9.5,23.516625 L9.5,51.384625 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384625 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944625 63.2245,20.367125 L39.09,6.433125 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.6%",
    y: "-9.5%",
    width: "143.2%",
    height: "138.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-bestellschnittstelle"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 29.241312 0 29.241312 19.297 0 19.297"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-color-gold",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bestellschnittstelle",
    transform: "translate(-1105.000000, -986.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bestell-schnittstelle",
    transform: "translate(598.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-bestellschnittstelle)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F2F3F4",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "stroke-color",
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944125 9.5,22.361625 9.5,23.516625 L9.5,51.384125 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384125 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944125 63.2245,20.367125 L39.09,6.433125 Z",
    id: "border",
    stroke: "#666666",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,6 C36.8886346,6.01803249 36.2852285,6.15628155 35.8201132,6.42676886 L11.8092236,20.3859175 C10.8138273,20.9644598 10,22.3840172 10,23.5411018 L10,51.4588982 C10,52.6159828 10.8138273,54.0360411 11.8092236,54.6145834 L35.8201132,68.5732311 C36.2852285,68.8437184 36.8886346,68.9824684 37.5,69 L37.5,6 Z",
    id: "overlay",
    fill: "#666666",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-bestellschnittstelle",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M24.8248,13.2735 L9.6298,13.2735 L7.4478,5.1215 L26.9473,5.1215 L24.8248,13.2735 Z M29.0323,3.51 C28.8433,3.265 28.5508,3.1215 28.2413,3.1215 L6.9123,3.1215 L6.8348,2.832 C6.3113,1.138 4.7658,0 2.9888,0 L0.9998,0 C0.4478,0 -0.0002,0.4475 -0.0002,1 C-0.0002,1.552 0.4478,2 0.9998,2 L2.9888,2 C3.8833,2 4.6613,2.5715 4.9138,3.386 L5.1403,4.232 C5.1453,4.2825 5.1548,4.332 5.1678,4.381 L7.8623,14.406 L7.8623,16.9325 C7.8623,18.2365 8.9233,19.297 10.2273,19.297 L24.7033,19.297 C25.2553,19.297 25.7033,18.849 25.7033,18.297 C25.7033,17.7445 25.2553,17.297 24.7033,17.297 L10.2273,17.297 C10.0258,17.297 9.8623,17.1335 9.8623,16.9325 L9.8623,15.2735 L25.6278,15.2735 C26.1733,15.2735 26.6148,14.8365 26.6258,14.294 L29.2088,4.3735 C29.2873,4.074 29.2218,3.755 29.0323,3.51 L29.0323,3.51 Z",
    id: "Fill-1",
    fill: "#676767",
    mask: "url(#mask-bestellschnittstelle)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M21.46535,23.4947 C20.99685,23.4947 20.61585,23.1132 20.61585,22.6447 C20.61585,22.1757 20.99685,21.7947 21.46535,21.7947 C21.93385,21.7947 22.31535,22.1757 22.31535,22.6447 C22.31535,23.1132 21.93385,23.4947 21.46535,23.4947 M21.46535,19.7947 C19.89385,19.7947 18.61585,21.0727 18.61585,22.6447 C18.61585,24.2162 19.89385,25.4947 21.46535,25.4947 C23.03735,25.4947 24.31535,24.2162 24.31535,22.6447 C24.31535,21.0727 23.03735,19.7947 21.46535,19.7947",
    id: "Fill-4",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M12.58545,23.4947 C12.11695,23.4947 11.73595,23.1132 11.73595,22.6447 C11.73595,22.1757 12.11695,21.7947 12.58545,21.7947 C13.05395,21.7947 13.43545,22.1757 13.43545,22.6447 C13.43545,23.1132 13.05395,23.4947 12.58545,23.4947 M12.58545,19.7947 C11.01395,19.7947 9.73595,21.0727 9.73595,22.6447 C9.73595,24.2162 11.01395,25.4947 12.58545,25.4947 C14.15745,25.4947 15.43545,24.2162 15.43545,22.6447 C15.43545,21.0727 14.15745,19.7947 12.58545,19.7947",
    id: "Fill-6",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M12.28515,9.95125 L22.08965,9.95125 C22.64215,9.95125 23.08965,9.50325 23.08965,8.95125 C23.08965,8.39925 22.64215,7.95125 22.08965,7.95125 L12.28515,7.95125 C11.73315,7.95125 11.28515,8.39925 11.28515,8.95125 C11.28515,9.50325 11.73315,9.95125 12.28515,9.95125",
    id: "Fill-8",
    fill: "#676767"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestellschnittstelle);
export default __webpack_public_path__ + "static/media/bestellschnittstelle.a86fb7f9f8b5599a26b579428185cbb2.svg";
export { ForwardRef as ReactComponent };